<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="packageService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true"
        [value]="packages"
        pDroppable="row">

        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Paquetes
              </div>
              <div class="col-8 text-end">

                <button (click)="packageService.getAll(neighborhoodId!)" class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>

            <th></th>

            <th pSortableColumn="parcelService.parcelService">
              Paquetería
              <p-sortIcon field="parcelService.parcelService"></p-sortIcon>
              <p-columnFilter type="text" field="parcelService.parcelService" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="streetBuilding.name">
              Calle
              <p-sortIcon field="streetBuilding.name"></p-sortIcon>
              <p-columnFilter type="text" field="streetBuilding.name" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="houseFlat.number">
              Casa
              <p-sortIcon field="houseFlat.number"></p-sortIcon>
              <p-columnFilter type="text" field="houseFlat.number" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="gate.gateName">
              Ubicación
              <p-sortIcon field="gate.gateName"></p-sortIcon>
              <p-columnFilter type="text" field="gate.gateName" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="packagesNumber">
              No. paquetes
              <p-sortIcon field="packagesNumber"></p-sortIcon>
              <p-columnFilter type="text" field="packagesNumber" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="createdAt">
              Llegada
              <p-sortIcon field="createdAt"></p-sortIcon>
              <p-columnFilter type="date" field="createdAt" display="menu"></p-columnFilter>
            </th>

            @if(pickupDate) {
              <th pSortableColumn="pickedUpAt">
                Recogido
                <p-sortIcon field="pickedUpAt"></p-sortIcon>
                <p-columnFilter type="date" field="pickedUpAt" display="menu"></p-columnFilter>
              </th>
            }

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-package>
          <tr class="p-selectable-row">

            <td>
              @if(package.parcelService && package.parcelService.image) {
                <div 
                  class="bg-center"
                  style="width: 5vh; height: 5vh;"
                  [ngStyle]="{
                    'background-image': 'url(' + package.parcelService.image.urlFile + ')'
                  }">
                </div>
              }
            </td>

            <td>
              <span class="p-column-title">Paquetería</span>
              {{ package.parcelService ? package.parcelService.parcelService : '' }}
            </td>

            <td>
              <span class="p-column-title">Calle</span>
              {{ package.streetBuilding ? package.streetBuilding.name : '' }}
            </td>

            <td>
              <span class="p-column-title">Casa</span>
              {{ package.houseFlat ? package.houseFlat.number : '' }}
            </td>

            <td>
              <span class="p-column-title">Ubicación</span>
              {{ package.gate ? package.gate.gateName : '' }}
            </td>

            <td>
              <span class="p-column-title">No. paquetes</span>
              {{ package.packagesNumber }}
            </td>

            <td class="text-center">
              <span class="p-column-title">Fecha</span>
              {{package.createdAt | dateToMoment: 'DD MMM yyyy HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
            </td>

            @if(pickupDate) {
              <td class="text-center">
                <span class="p-column-title">Recogido</span>
                {{package.pickedUpAt | dateToMoment: 'DD MMM yyyy HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
              </td>
            }

            <td>

              <button 
                class="btn btn-sm btn-light rounded-circle me-2"
                (click)="open(package)">
                <i class="material-icons mt-1">more_vert</i>
              </button>
              
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
